import "sanitize.css";
import "aos/dist/aos.css";

import React, { useEffect } from "react";
import { StaticQuery, graphql, navigate } from "gatsby";

import AOS from "aos";
import Footer from "./Footer";
import { GlobalStyle } from "../globalStyle";
import Header from "./Header";
import Helmet from "react-helmet";
import { ThemeProvider } from "styled-components";
import og from "../images/og.png";
import { smoothScroll } from "../../utils/util";
import smoothscroll from "smoothscroll-polyfill";
import theme from "../theme";

const Layout: React.FC = ({
    children,
    location,
}: {
    children: React.ReactNode;
    location: any;
}) => {
    useEffect(() => {
        smoothscroll.polyfill();
        AOS.init({
            duration: 2000,
            once: true,
        });
    }, []);

    const firstItemClicked = () => {
        navigate("/o-instrumentech");
    };

    const secondItemClicked = () => {
        navigate("/slovnik");
    };

    const dotaznikItemClicked = () => {
        navigate("/");
        setTimeout(() => {
            smoothScroll("faq", 140);
        }, 100);
    };

    return (
        <ThemeProvider theme={theme}>
            <>
                <Helmet
                    title="Patria Finance – Investiční dotazník"
                    meta={[
                        {
                            name: "description",
                            content: "Dobrá pomoc při volbě investic",
                        },
                        {
                            name: "og:description",
                            content: "Dobrá pomoc při volbě investic",
                        },
                        {
                            name: "og:title",
                            content: "Nový investiční dotazník",
                        },
                        { name: "og:image", content: og },
                    ]}
                    script={[
                        {
                            innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-5LBP63L');`,
                        },
                    ]}
                >
                    <html lang="en" />
                </Helmet>
                <noscript>
                    <iframe
                        src="https://www.googletagmanager.com/ns.html?id=GTM-5LBP63L"
                        height="0"
                        width="0"
                        style={{ display: "none", visibility: "hidden" }}
                    ></iframe>
                </noscript>
                <GlobalStyle />
                <Header
                    firstClick={() => firstItemClicked()}
                    secondClick={() => secondItemClicked()}
                    dotaznikClick={dotaznikItemClicked}
                    location={location}
                />
                <div style={{ overflowX: "hidden" }}>{children}</div>
                <Footer text="Informace uveřejněné na stránkách Patria Finance, a.s. nejsou (není-li uvedeno jinak) analýzou investičních příležitostí ani investičním doporučením. Názory a doporučení zde uvedené neberou v úvahu situaci a osobní poměry jednotlivých investorů, jejich finanční situaci, znalosti, zkušenosti, cíle nebo potřeby. Investiční nástroje, které mohou zákazníci prostřednictvím Patria Finance a.s. nakoupit/prodat nemusejí být pro konkrétní zákazníky vhodné. S obchodováním na kapitálovém trhu je spojeno riziko ztráty investice, rizika spojená s jednotlivými investičními nástroji a další informace týkající se obchodování na kapitálovém trhu a společnosti Patria Finance, a.s. jsou uveřejněny na finance.patria.cz." />
            </>
        </ThemeProvider>
    );
};

export default Layout;
